export default __webpack_public_path__ + "static/media/Quicksand-Medium.7bd2b557.eot";